import React, { FC, memo } from "react";
import Link from "next/link";
import Image from "next/image";
import styles from "./program-card.module.scss";
import { USRemover } from "./Programs";
import ArrowRight from "@/SvgIcons/ArrowRight";
interface Program {
  url: string;
  IconUrl: { url: string };
  Title: string;
  year: string;
  signifiers?: {
    tagName?: string;
    hexCode?: string;
  };
}
interface ProgramCardProps {
  program: Program;
}

const ProgramCard: FC<ProgramCardProps> = ({ program }) => {
  const { signifiers } = program;
  const tagName = signifiers?.tagName || null;
  const hexCode = signifiers?.hexCode || null;

  return (
    <Link
      href={`/${program.url}`}
      className={styles.card}
      aria-label={`Go to ${program.Title}`}
    >
      <Image
        src={program?.IconUrl?.url}
        alt={program.Title}
        height={25}
        width={25}
        className={styles.programIcon}
        loading="lazy"
        decoding="async"
      />
      <span className={styles.cardTitle}>
        {program.Title}
        <ArrowRight
          color="#1a325d"
          width={19}
          height={19}
          className={styles.rightArrow}
        />
      </span>
      <span className={styles.duration}>{program.year}</span>
      {tagName && (
        <span
          className={styles.cardTag}
          style={{ backgroundColor: hexCode || "transparent" }}
        >
          {USRemover(tagName)}
        </span>
      )}
    </Link>
  );
};

export default memo(ProgramCard);
